import crypto from 'crypto-js';
import { isString, isEmpty } from 'lodash';

import env from 'env';

const formatToken = (token: string) => token?.replace(/\./g, '=').replace(/-/g, '+').replace(/_/g, '/');

export const encryptAesToken = (data: string): string => {
  if (isString(data)) {
    // Encryption config
    const encryptionKey = crypto.enc.Latin1.parse(env.AES_KEY?.padEnd(32, '\0') ?? '');
    const encryptionOptions = {
      iv: crypto.enc.Latin1.parse(env.AES_IV?.padEnd(32, '\0') ?? ''),
      keySize: 256,
      mode: crypto.mode.CBC,
    };

    // Encrypt data
    const encrypt = crypto.AES.encrypt(data, encryptionKey, encryptionOptions);
    return btoa(encrypt as any)
      .replace(/=/g, '.')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  } else {
    console.error('Encryption error: data must be a string');
    return '';
  }
};

export const decryptAesToken = (token: string): string => {
  if (isString(token) && !isEmpty(token)) {
    // Check token encoded
    try {
      window.atob(formatToken(token));
    } catch (_e) {
      console.error('Invalid token:', token);
      return '';
    }

    // Decode url token
    const decodedToken = atob(formatToken(token));

    // Decryption config
    const decryptKey = crypto.enc.Latin1.parse(env.AES_KEY?.padEnd(32, '\0') ?? '');
    const decryptOptions = {
      iv: crypto.enc.Latin1.parse(env.AES_IV?.padEnd(32, '\0') ?? ''),
      keySize: 256,
      mode: crypto.mode.CBC,
    };

    // Decrypt data
    return crypto.AES.decrypt(decodedToken, decryptKey, decryptOptions).toString(crypto.enc.Utf8);
  } else return '';
};
